import { useCallback, useMemo } from "react";
import { useAppDispatch, useAppSelector, useIsLoggedSelector } from "../services/hooks.service";
import { loginTokenService } from "../services/localStorage.service";
import { useUltradeWallet } from "./useUltradeWallet";
import { setNetworkConfig } from "../redux/_actions/network.action";
import { equalsIgnoreCase } from "../_utils";

export const useMainWallet = () => {
  const activeAddress = useAppSelector((state) => state.user.activeAddress);
  const mainAddress = useAppSelector((state) => state.user.mainAddress);
  const network = useAppSelector((state) => state.network);
  const isLogged = useIsLoggedSelector();
  const { connect, disconnect } = useUltradeWallet();
  const dispatch = useAppDispatch();
  
  const isMainWallet = useMemo(() => {
    // console.log('isMainWallet', { mainAddress, activeAddress })
    return !mainAddress || equalsIgnoreCase(mainAddress, activeAddress);
  }, [activeAddress, mainAddress, isLogged]);

  const reconnect = useCallback(async () => {
    const mainWallet = loginTokenService.getMainWallet();
    if (mainWallet) {
        await disconnect();
        dispatch(setNetworkConfig({...network, chain: mainWallet.chain, provider: mainWallet.provider}))
        await connect(mainWallet.chain, mainWallet.provider);
    }
  }, [mainAddress, disconnect]);


  return {
    isMainWallet,
    reconnect
  };
}



